<template>
  <div class="section">
    <div class="container" v-if="lang==1">
      <h1 class="title" >ຍິນດີຕອນຮັບ ເຂົ້າສູ້ລະບົບເວັບໄຊ ສະມາຄົມ ທຸລະກິດກະສິກຳ ລາວ </h1><br>
      <!-- <b-field>
        ຕາຕະລາງ-ວາລະຂອງງານ ວາງສະແດງສິນຄ້າກະສິກຳ ປະຈຳປີ 2024
      </b-field> -->
      <b-field>
        <div class="columns">
          
          <div class="column column-65" >
            <b-field>
              <img :src="imageSrc1" alt="" />
            </b-field>
            <b-field>
              <img :src="imageSrc2" alt="" />  
            </b-field>
            <!-- <table class="table is-fullwidth is-narrow is-small" >
              <thead>
                <tr>
                  <th class="has-text-left " width="2%">
                     #
                  </th>
                  <th class="has-text-left " width="40%">
                    ຊື່ງານ/ Event
                  </th>
                  
                  <th class="has-text-left " width="20%">
                    ວັນ ແລະ ເວລາ
                  </th>
                  
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in eventList"
                  :key="data.ID"
                >
                  <td class="has-text-left ">
                    {{ index +1 }}
                  </td>
                  <td class="has-text-left ">
                    {{ data.NAME }}    
                  </td> 

                  <td class="has-text-left ">
                    {{ dateFormatter(data.STARTDATE) }} 
                    <span v-if="!data.STARTTIME"> 09:00</span>
                    <span v-else>{{ data.STARTTIME }}</span> 
                    -
                    <span v-if="!data.ENDTIME"> 11:00</span>
                    <span v-else>{{ data.ENDTIME }}</span> 
                  </td> 
                    
                
                  
                </tr>
              </tbody>
              
            </table> -->
          </div>
          <div class="column column-35">
            <div class="columns">
              <div class="column">
                <b-field>
                ສະຖິຕິຜູ້ລົງທະບຽນເຂົ້າຮ່ວມງານ ວາງສະແດງສິນຄ້າກະສິກຳ ປະຈຳປີ 2024
              </b-field>
              <table class="table is-fullwidth is-narrow is-small" >
                <thead>
                  <tr>
                    <th class="has-text-left " width="40%">
                      ພາກສ່ວນ
                    </th>
                    
                    <th class="has-text-right " width="25%">
                      ຈຳນວນຄົນ
                    </th>
                    
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(data) in sectionList"
                    :key="data.SECTIONID"
                  >
                    <td class="has-text-left ">
                      {{ data.SECTIONNAME }}    
                    </td> 

                    <td class="has-text-right ">
                      {{ data.COUNTSECTION }}
                    </td> 
                      
                  
                    
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th class="has-text-right">
                      ລວມ
                    </th>
                    <th class="has-text-right">
                      {{
                        _.sumBy(sectionList, (i) => i["COUNTSECTION"] * 1)
                          | formatNumberLocal
                      }}
                    </th>
                  </tr>
                </tfoot>
                
              </table>

              <table class="table is-fullwidth is-narrow is-small" >
                <thead>
                  <tr>
                    <th class="has-text-left " width="40%">
                      ຊ່ວງອາຍຸ
                    </th>
                    
                    <th class="has-text-right " width="25%">
                      ຈຳນວນຄົນ
                    </th>
                    
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(data) in ageList"
                    :key="data.ID"
                  >
                    <td class="has-text-left ">
                      {{ data.AGETITLE }}    
                    </td> 

                    <td class="has-text-right ">
                      {{ data.COUNTAGE }}
                    </td> 
                      
                  
                    
                  </tr>
                </tbody>
                
              </table>


              <table class="table is-fullwidth is-narrow is-small" >
                <thead>
                  <tr>
                    <th class="has-text-left " width="40%">
                      ຫົວຂໍ້ທີ່ສົນໃຈ
                    </th>
                    
                    <th class="has-text-right " width="25%">
                      ຈຳນວນຄົນ
                    </th>
                    
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(data) in interestedList"
                    :key="data.INTERESTEDID"
                  >
                    <td class="has-text-left ">
                      {{ data.INTERESTEDTITLE }}    
                    </td> 

                    <td class="has-text-right ">
                      {{ data.COUNTINTERESTED }}
                    </td> 
                      
                  
                    
                  </tr>
                </tbody>
                
              </table>
              <table class="table is-fullwidth is-narrow is-small" v-if="boothList.length > 0">
                <thead>
                  <tr>
                    <th class="has-text-left " width="40%">
                      ບູ໊ດວາງສະແດງ
                    </th>
                    
                    <th class="has-text-right " width="25%">
                      ຈຳນວນ
                    </th>
                    
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(data) in boothList"
                    :key="data.PROVINCEID"
                  >
                    <td class="has-text-left ">
                      {{ data.PROVINCENAME }}    
                    </td> 

                    <td class="has-text-right ">
                      {{ data.BOOTHCOUNT }}
                    </td> 
                      
                  
                    
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th class="has-text-right">
                      ລວມ
                    </th>
                    <th class="has-text-right">
                      {{
                        _.sumBy(boothList, (i) => i["BOOTHCOUNT"] * 1)
                          | formatNumberLocal
                      }}
                    </th>
                  </tr>
                </tfoot>
                
              </table>
                
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <b-field>
                  <b-button class="btn-group-margin is-fullwidth"
                            type="is-info"  
                            size="is-small"
                            @click="registerEventID(41)"
                            >  <span > ລົງທະບຽນເຂົ້າຮ່ວມງານຕ່າງໆ</span>
                        </b-button>
                  
                </b-field>
                <b-field>
                  <img :src="qrCode" alt="" />
                </b-field>
              </div>
            </div>
            

            
          </div>
        </div>
        
      </b-field>
        

      

      

      <!-- <b-field>
        
        <div>
          <img width="800px" :src="imageSrc4" alt="sponser" />
        </div>
      </b-field> -->
    </div>

    <div class="container" v-if="lang==2">
      <h1 class="title" >Welcome to Lao Agricultural Business Association Website</h1>
      
      <!--<b-field>
        Agri Expo 2024 Agenda
      </b-field> -->
      <b-field>
        <div class="columns">
          <div class="column column-65" >
            <b-field>
              <img :src="imageSrc1" alt="" />
            </b-field>
            <b-field>
              <img :src="imageSrc2" alt="" />
            </b-field>
            <!-- <table class="table is-fullwidth is-narrow is-small" >
              <thead>
                <tr>
                  <th class="has-text-left " width="2%">
                     #
                  </th>
                  <th class="has-text-left " width="40%">
                    Event
                  </th>
                  
                  <th class="has-text-left " width="20%">
                    Date and Time
                  </th>
                  
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in eventList"
                  :key="data.ID"
                >
                  <td class="has-text-left ">
                    {{ index +1 }}
                  </td>
                  <td class="has-text-left ">
                    {{ data.NAME }}    
                  </td> 

                  <td class="has-text-left ">
                    {{ dateFormatter(data.STARTDATE) }} 
                    <span v-if="!data.STARTTIME"> 09:00</span>
                    <span v-else>{{ data.STARTTIME }}</span> 
                    -
                    <span v-if="!data.ENDTIME"> 11:00</span>
                    <span v-else>{{ data.ENDTIME }}</span> 
                  </td> 
                    
                
                  
                </tr>
              </tbody>
              
            </table> -->
          </div>
          <div class="column column-35">
            <div class="columns">
              <div class="column">
                <b-field>
                  Statistic of Participate Expo 2024
              </b-field>
              <table class="table is-fullwidth is-narrow is-small" >
                <thead>
                  <tr>
                    <th class="has-text-left " width="40%">
                      Section
                    </th>
                    
                    <th class="has-text-right " width="25%">
                      Count
                    </th>
                    
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(data) in sectionList"
                    :key="data.SECTIONID"
                  >
                    <td class="has-text-left ">
                      {{ data.SECTIONNAME }}    
                    </td> 

                    <td class="has-text-right ">
                      {{ data.COUNTSECTION }}
                    </td> 
                      
                  
                    
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th class="has-text-right">
                      Total
                    </th>
                    <th class="has-text-right">
                      {{
                        _.sumBy(sectionList, (i) => i["COUNTSECTION"] * 1)
                          | formatNumberLocal
                      }}
                    </th>
                  </tr>
                </tfoot>
                
              </table>

              <table class="table is-fullwidth is-narrow is-small" >
                <thead>
                  <tr>
                    <th class="has-text-left " width="40%">
                      Age Rank
                    </th>
                    
                    <th class="has-text-right " width="25%">
                      Count
                    </th>
                    
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(data) in ageList"
                    :key="data.ID"
                  >
                    <td class="has-text-left ">
                      {{ data.AGETITLE }}    
                    </td> 

                    <td class="has-text-right ">
                      {{ data.COUNTAGE }}
                    </td> 
                      
                  
                    
                  </tr>
                </tbody>
                
              </table>


              <table class="table is-fullwidth is-narrow is-small" >
                <thead>
                  <tr>
                    <th class="has-text-left " width="40%">
                      Interested Topic
                    </th>
                    
                    <th class="has-text-right " width="25%">
                      Count
                    </th>
                    
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(data) in interestedList"
                    :key="data.INTERESTEDID"
                  >
                    <td class="has-text-left ">
                      {{ data.INTERESTEDTITLE }}    
                    </td> 

                    <td class="has-text-right ">
                      {{ data.COUNTINTERESTED }}
                    </td> 
                      
                  
                    
                  </tr>
                </tbody>
                
              </table>
                
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <b-field>
                  <b-button class="btn-group-margin is-fullwidth"
                            type="is-info"  
                            size="is-small"
                            @click="registerEventID(41)"
                            >  <span > Join Events</span>
                        </b-button>
                  
                </b-field>
                <b-field>
                  <img :src="qrCode" alt="" />
                </b-field>
              </div>
            </div>
            

            
          </div>
        </div>
        
      </b-field>
        

      

      

      <!-- <b-field>
        
        <div>
          <img width="800px" :src="imageSrc4" alt="sponser" />
        </div>
      </b-field> -->
    </div>
    <Footer />
  </div> 
  
</template>

<script>
import RestAPI from "../RestAPI";
import moment from "moment";

import Footer from "../components/menu/Footer";  
export default {
  components: {
    Footer,
  },
  name: "home",
  data() {
    return {
      eventList: [],
      sectionList: [],
      ageList: [],
      interestedList: [],
      boothList: [],
    };
  },
  methods: {   
    registerEventID(ID){
      this.$router.replace("/event/register/" + ID);
    },
    getEvent_public() {
      RestAPI.getEvent_public()
        .then((res) => {
          this.eventList = res.data.responseData.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getSectionParticipateNumber_public() {
      RestAPI.getSectionParticipateNumber_public()
        .then((res) => {
          this.sectionList = res.data.responseData.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getAgeRankParticipateNumber_public() {
      RestAPI.getAgeRankParticipateNumber_public()
        .then((res) => {
          this.ageList = res.data.responseData.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getInterestedParticipateNumber_public() {
      RestAPI.getInterestedParticipateNumber_public()
        .then((res) => {
          this.interestedList = res.data.responseData.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getBoothNumber_public() {
      RestAPI.getBoothNumber_public()
        .then((res) => {
          this.boothList = res.data.responseData.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    

    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    
  },
  
  mounted() {
    this.getEvent_public();  
    this.getSectionParticipateNumber_public();
    this.getAgeRankParticipateNumber_public();
    this.getInterestedParticipateNumber_public();
    this.getBoothNumber_public();
  },
  computed: {
    imageSrc1() {
      return process.env.NODE_ENV === 'production'
        ? 'https://lababiz.com/api/uploads/pages/news/page1.png'
        : 'http://localhost/lababiz/api/uploads/pages/news/page1.png';
    },

    // Using pathify
    imageSrc2() {
      
      return process.env.NODE_ENV === 'production'
        ? 'https://lababiz.com/api/uploads/pages/news/news02/news02-01.png'
        : 'http://localhost/lababiz/api/uploads/pages/news/news02/news02-01.png';
    },

    qrCode() {
      return process.env.NODE_ENV === 'production'
        ? 'https://lababiz.com/api/uploads/qr/qrcode.png'
        : 'http://localhost/lababiz/api/uploads/qr/qrcode.png';
    },

    lang() {
     
      return this.$store.get('switchLang') || 1;
    },
  },
};
</script>

<style scoped>
.column-65 {
  flex: 0 0 70%;
}
.column-35 {
  flex: 0 0 30%;
}
</style>
